import { render, staticRenderFns } from "./pMember.vue?vue&type=template&id=64efd15c&scoped=true"
import script from "./pMember.vue?vue&type=script&lang=js"
export * from "./pMember.vue?vue&type=script&lang=js"
import style0 from "./pMember.vue?vue&type=style&index=0&id=64efd15c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64efd15c",
  null
  
)

export default component.exports